$('.card-slider').each((i, el) => {
	const $slider = $(el);
	const $track = $slider.children('.acf-innerblocks-container');
	const { prevArrow, nextArrow } = Globals.sliders;
	const $controls = $slider.next('.js-slider-controls');
  
	const options = {
	  mobileFirst: true,
	  dots: true,
	  prevArrow,
	  nextArrow,
	  appendArrows: $controls,
	  appendDots: $controls,
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  infinite: true,
	  rows: 0,
	  centerMode: true,
	  centerPadding: '12px',
  	  responsive: [
		{
		  breakpoint: 781,
		  settings: {
			centerMode: false,
			centerPadding: '0px'
		  }
		}
	  ]
	};
  
	$track.on('init reInit setPosition', function (evt, slick) {
	  if (!slick) return;
	  const count = slick.slideCount;
	  const sts = slick.options.slidesToShow || 1;
	  const canSlide = count > sts;
	  if ($controls && $controls.length) {
		$controls.toggle(!!canSlide);
	  }
	});
  
	$track.addClass('slick-equal-heights');
	$track.slick(options);
  
	if ($track.find('.slick-track').length === 0) {
	  $track.find('> *').removeAttr('aria-describedby role tabindex aria-hidden');
	  $track.find('a[tabindex="-1"], button[tabindex="-1"]').removeAttr('tabindex');
	}
  });
  